import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "arw_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// content
export const getBooks = () => api.get("/books").then((r) => r.data);
export const getBook = (slug) => api.get(`/books/${slug}`).then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getAuthor = () => api.get("/author").then((r) => r.data);
export const subscribe = (payload) => api.post("/subscribe", payload).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// community
export const getCategories = () => api.get("/community/categories").then((r) => r.data);
export const getChallenge = () => api.get("/community/challenge").then((r) => r.data);
export const getPosts = (category) =>
  api.get("/community/posts", { params: category ? { category } : {} }).then((r) => r.data);
export const getThread = (id) => api.get(`/community/posts/${id}`).then((r) => r.data);
export const createPost = (payload) => api.post("/community/posts", payload).then((r) => r.data);
export const createReply = (postId, payload) =>
  api.post(`/community/posts/${postId}/replies`, payload).then((r) => r.data);
export const likePost = (id) => api.post(`/community/posts/${id}/like`).then((r) => r.data);
export const likeReply = (id) => api.post(`/community/replies/${id}/like`).then((r) => r.data);

// admin
export const adminLogin = (payload) => api.post("/admin/login", payload).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const pinPost = (id) => api.post(`/admin/posts/${id}/pin`).then((r) => r.data);
export const hidePost = (id) => api.post(`/admin/posts/${id}/hide`).then((r) => r.data);
export const deletePost = (id) => api.delete(`/admin/posts/${id}`).then((r) => r.data);
export const hideReply = (id) => api.post(`/admin/replies/${id}/hide`).then((r) => r.data);
export const deleteReply = (id) => api.delete(`/admin/replies/${id}`).then((r) => r.data);

// tracking
export const getVisitorId = () => {
  let v = localStorage.getItem("arw_visitor");
  if (!v) {
    v = (window.crypto?.randomUUID && window.crypto.randomUUID()) || String(Math.random()).slice(2);
    localStorage.setItem("arw_visitor", v);
  }
  return v;
};
export const track = (kind, path) =>
  api.post("/track", { kind, path, visitor: getVisitorId() }).catch(() => {});

// admin: activity feed, analytics, blog management
export const getActivities = (unreadOnly = false) =>
  api.get("/admin/activities", { params: { unread_only: unreadOnly } }).then((r) => r.data);
export const getUnreadCount = () => api.get("/admin/activities/unread_count").then((r) => r.data);
export const markAllRead = () => api.post("/admin/activities/read_all").then((r) => r.data);
export const getAnalytics = () => api.get("/admin/analytics").then((r) => r.data);
export const createBlog = (p) => api.post("/admin/blog", p).then((r) => r.data);
export const updateBlog = (slug, p) => api.put(`/admin/blog/${slug}`, p).then((r) => r.data);
export const deleteBlog = (slug) => api.delete(`/admin/blog/${slug}`).then((r) => r.data);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ");
  return "Something went wrong. Please try again.";
}
